const Checkout = () => {
    return(
        <div>
            <div>
                <h1>My Order</h1>
                <div>
                    <div>
                        <p>
                            <span>03.25.21</span>
                            <span>6 articles</span>
                        </p>
                        <p>$560.000</p>
                    </div>
                </div>
               
            </div>
        </div>
    )
}

export default Checkout